// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kKCT","colBig":"styles_colBig__3h5GZ","colSmall":"styles_colSmall__2W7Il","shopifyNameWrapper":"styles_shopifyNameWrapper__P-f0P"};